import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";

import { Dialog, FlatButton } from "material-ui";
import ContentCreate from "material-ui/svg-icons/content/create";

import { List, FilterForm, Datagrid } from "components/list";
import { TextInput } from "components/input";
import { TextField } from "components/field";
import compose from "recompose/compose";

import { COUNTRY_TH, COUNTRY_VN } from "util/constants";
import { changeCrudResourceData } from "actions";
import { shopLoginDisableBackendPath } from "./urls";

import {
  ownerChangeMobileFrontendPath,
  ownerAdminChangeMobileFrontendPath,
  ownerMergeShopFrontendPath,
} from "./urls";
import { shopLoginDisableRevert, crudGetList } from "actions";

const ListFilter = (props) => (
  <FilterForm name="disabled_account_search" {...props}>
    <TextInput label="Mobile" source="mobile_number" />
  </FilterForm>
);

const RevertButton = (props) => {
  const { record } = props;
  return record.reverted ? null : (
    <FlatButton
      {...props}
      primary
      label="Revert"
      onClick={() => props.openConfirmDialog(props.record.uid)}
    />
  );
};

const CurrentStatus = (props) => {
  const { record } = props;
  const newRecord = {};
  newRecord["status_name"] = record["reverted"] ? "Enabled" : "Disabled";
  return <TextField {...props} source="status_name" record={newRecord} />;
};

class ShopLoginDisableList extends Component {
  state = {
    isOpenConfirmDialog: false,
    uid: "",
  };

  openConfirmDialog = (uid) => {
    this.setState({
      isOpenConfirmDialog: true,
      uid: uid,
    });
  };

  revertShopLoginDisable = () => {
    this.props.dispatch(
      shopLoginDisableRevert(
        {
          uid: this.state.uid,
        },
        true,
        () => {
          const { filterValues } = this.props;
          this.props.dispatch(
            crudGetList(
              this.props.resource,
              this.props.backendPath,
              filterValues
            )
          );
        }
      )
    );
    this.setState({
      isOpenConfirmDialog: false,
    });
  };

  handleCloseConfirmDialog = () => {
    this.setState({
      isOpenConfirmDialog: false,
    });
  };

  render() {
    const actions = [
      <FlatButton label="No" onTouchTap={this.handleCloseConfirmDialog} />,
      <FlatButton
        label="Yes"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.revertShopLoginDisable}
      />,
    ];

    return (
      <div>
        <List
          title={"Disabled account requested by user"}
          hasCreate={true}
          {...this.props}
          filters={<ListFilter />}
        >
          <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
            <TextField source="mobile_number" label="Mobile" />
            <CurrentStatus label="Current Status" />
            <TextField source="disable_time" label="Disable Time" />
            <TextField source="reverted_by" label="Revert Operator Email" />
            <TextField source="revert_time" label="Revert Time" />
            <RevertButton
              label="action"
              openConfirmDialog={this.openConfirmDialog}
            />
          </Datagrid>
        </List>
        <Dialog
          title="Confirm"
          actions={actions}
          modal={false}
          open={this.state.isOpenConfirmDialog}
        >
          Are you sure you want to do this action?
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  const resourceState = state.admin[props.resource];
  return {
    backendPath: shopLoginDisableBackendPath,
    resource: props.resource,
    filterValues: state.admin.filter[props.resource],
    data: resourceState.data,
  };
}

export default connect(mapStateToProps)(ShopLoginDisableList);



// WEBPACK FOOTER //
// ./src/routes/shop/ShopLoginDisable.js